import axios from 'axios';
import type { AxiosInstance, AxiosRequestConfig } from 'axios';

import { getAuthToken } from 'utils/auth';

const BASE_URL_API = `${process.env.REACT_APP_BASE_URL_API}/api`;
const BASE_URL_API_PAY = `${process.env.REACT_APP_BASE_URL_API_PAY}/api`;
const BASE_URL_ONBOARDING_API = process.env.REACT_APP_BASE_URL_ONBOARDING_API;

const baseHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'Accept-Language': 'es-MX',
};

/**
 * Injects the current auth token on every request.
 * Reads the token fresh from the cookie per call so token rotation,
 * late login, and store switches stay in sync with outgoing requests.
 */
const attachAuthInterceptor = (instance: AxiosInstance): AxiosInstance => {
  instance.interceptors.request.use((config: AxiosRequestConfig) => {
    const token = getAuthToken()?.accessToken;
    if (token) {
      config.headers = { ...config.headers, Authorization: `Bearer ${token}` };
    }
    return config;
  });
  return instance;
};

export const onboardingApi = attachAuthInterceptor(
  axios.create({
    baseURL: BASE_URL_API,
    headers: baseHeaders,
  }),
);

export const onboardingPayApi = attachAuthInterceptor(
  axios.create({
    baseURL: BASE_URL_API_PAY,
    headers: baseHeaders,
  }),
);

export const onboardingAdminApi = attachAuthInterceptor(
  axios.create({
    baseURL: BASE_URL_ONBOARDING_API,
    headers: baseHeaders,
  }),
);
